<template>
  <audio ref="audio">
    <source src="../assets/1.mp3">
  </audio>
</template>
<script>
export default {
  name: 'PosSound',
  data () {
    return {
      sound: ''
    }
  },
  created: function () {
    this.sound = '../assets/' + this.$store.state.sound;
  },
  watch: {
    sound(newV, oldV) {
      //console.log(newV, oldV)
      //this.$refs.audio.src = '../assets/' + this.$store.state.sound;
      this.$refs.audio.play();
      setTimeout(() => {
        this.$store.commit('setSound','')
      }, 1000);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PosSound.vue